import React, { Component} from 'react';
import PropTypes from 'prop-types';
import DeliveryRule from './deliveryrule';
import Ticket from './ticket';
import CartSubItem from './cartsubitem';
import cIf from 'classnames';
import { noop } from 'lodash';
import { ProductTypeEnum } from '../../src/types/models';
import { SiteCustomizationContext } from '../../src/logic/reactcontext/site-customization-context';
import { EMPTY_UUID } from '../../src/logic';

const tr = require('ts-translate-js').default.boundTR;
const accounting = require('accounting');
const modal = require('../modal');
const moment = require('moment');

const PRODUCT_TYPE = {
    Ticket: 0,
    PrepaidCard: 1,
    MembershipCard: 2,
    Product: 3,
    Donation: 4
};

const ITEM_TYPE = {
    Event: 0,
    Package: 1
};

class CartItem extends Component {
    // Since readonly is only available in TS, we need to disable that eslint rule for now
    //eslint-disable-next-line sonarjs/public-static-readonly
    static contextType = SiteCustomizationContext;

    constructor(props) {
        super(props);
        this.state = {
            showConfirmRemove: false,
            confirmStyle: {},
            detailsShown: props.cartItem.ProductType == PRODUCT_TYPE.Ticket,
            showButtonModifySaleQuestionnaires: false
        };

        this.handleOpenSaleQuestionnaireFormByID = this.handleOpenSaleQuestionnaireFormByID.bind(this);
        this.handleOnNoRemove = this.handleOnNoRemove.bind(this);
        this.handleOnYesRemove = this.handleOnYesRemove.bind(this); 
        
        this.modalContainerRef = React.createRef();
    }

    componentDidMount(){
        if(this.props.onContentChange !== undefined) this.props.onContentChange(); // TODO: Ca sert à quoi ça?
    }

    componentDidUpdate(){
        if(this.props.onContentChange !== undefined) this.props.onContentChange(); // TODO: Ca sert à quoi ça?
    }

    handleRemoveOnClick(e){
        this.setState({
            showConfirmRemove: true, 
            confirmStyle:({"top":e.clientY})
        });
    }

    handleOnYesRemove(){
        this.setState({showConfirmRemove: false});
        this.props.onRemoveItem(this.props.cartItem.ID);
    }

    handleOnNoRemove(){
        this.setState({showConfirmRemove: false});
    }

    handleShowDetails(){
        this.setState({detailsShown: !this.state.detailsShown});
    }

    handleUpdateDeliveryMethod(isMailDelivery, isEticketDelivery, shippingFeeId) {
        this.props.onUpdateDeliveryMethod(this.props.cartItem.ID, isMailDelivery, isEticketDelivery, shippingFeeId);
    }

    
    handleOpenSaleQuestionnaireFormByID(packageID, eventID, eventDateID, ticketIDs) {
        tsapp.mvcapi.postCtl("cart/getsalequestionnaireresult", { packageID: packageID, eventID: eventID, eventDateID: eventDateID, cartID: EMPTY_UUID, ownerPOSID: 0, ticketIDs: ticketIDs })
             .success((saleQuestionnaires) =>
                 {
                     if(saleQuestionnaires.IsSuccess) 
                         this.props.onModifySaleQuestionnaire(saleQuestionnaires.result);
                 })
             .notSuccess((saleQuestionnaires) =>
                     {
                         if(!saleQuestionnaires.IsSuccess) {
                             alert("Le panier est expiré!");
                             this.props.onReloadCart();
                         }
                     });
    }
    
    createPopupMessage(showConfirmRemove) {
        return (
            this.state.showConfirmRemove
                     ? <modal.ConfirmYesNo 
                            showCloseButton={false}
                            title={tr("cartcontent.confirmtitle")}
                            messagehtml={tr("cartcontent.confirmremoveitem")}
                            onNo={this.handleOnNoRemove} 
                            onYes={this.handleOnYesRemove} 
                            style={this.state.confirmStyle}
                            showModal={showConfirmRemove}
                            container={this.modalContainerRef.current}
                            onClose={noop}
                        />
                     : null
        );
    }

    isTicket() {
        return this.props.cartItem.Type == ITEM_TYPE.Event && this.props.cartItem.ProductType == PRODUCT_TYPE.Ticket;
    }

    getProductNameAndDate() {
        return (this.isTicket() && !this.props.cartItem.DateToBeDeterminated
        ? this.props.cartItem.Name + " - " + moment(this.props.cartItem.Date).format(tr('cartcontent.dateformat'))
        : this.props.cartItem.Name);
    }

    render() {
        const { siteSettings } = this.context;
        let isProductItem = false;
        let hasSubProduct = this.props.cartItem.SubProducts.length > 0;

        if (this.props.cartItem.ProductType != PRODUCT_TYPE.Ticket) {
            isProductItem = true;
        }

        const popupMsg = this.createPopupMessage(this.state.showConfirmRemove);

        

        const venueName = !hasSubProduct && !isProductItem
                      ? <span>{tr("cartcontent.venue")} {this.props.cartItem.VenueName}</span>
                      : null;

        const productName = this.getProductNameAndDate();

        let detailsName = "";

        // Dans tous les cas on affiche détails au lieu de billets car lorsque c'est un produit on ne veut plus voir le mot billet
        detailsName = this.state.detailsShown
                    ? tr('cartcontent.hidedetails')
                    : tr('cartcontent.showdetails');


        const removeItemLink = this.props.readOnly
                           ? null
                           //TODO: Refactor this as a button
                           // eslint-disable-next-line sonarjs/anchor-is-valid
                           : <a href="#" onClick={(e) => this.handleRemoveOnClick(e)}>{tr("cartcontent.removeitem")}</a>;

        const buttonModifySaleQuestionnaires = (this.props.cartItem.SaleQuestionnaire != null && !this.props.cartItem.SaleQuestionnaire.HaveUnfilledQuestionnaire)
                                           ? (
                                               <div className="row" style={{marginTop:'4px'}}>
                                                   <div className="col-md-12">
                                                       <button type="button" className="btn btn-primary btn-xs" onClick={() => this.handleOpenSaleQuestionnaireFormByID(this.props.cartItem.SaleQuestionnaire.PackageID, this.props.cartItem.SaleQuestionnaire.EventID, this.props.cartItem.SaleQuestionnaire.EventDateID, this.props.cartItem.SaleQuestionnaire.TicketIDs)}>{tr("Modifier le formulaire")}</button>
                                                   </div>
                                               </div>
                                           )
                                           : null;
        

        return(
            <tr>
                <td>
                    <div ref={this.modalContainerRef} />
                    {popupMsg}
                    <div className="row">
                        <div className="col-md-12">
                            <strong>{productName}</strong> {removeItemLink}
                        </div>
                    </div>
                    
                    <div className="row">
                        <div className="col-md-12">
                            {venueName}
                        </div>
                    </div>
                    
                    <div className="row">
                        <div className="col-xs-12 btn-toolbar">
                            <div className="btn-group hidden-xs">
                                <button type="button" className={cIf({ btn: true, "btn-default": true, "btn-xs": true, active: this.state.detailsShown } )} onClick={() => this.handleShowDetails()}>
                                    <span className="glyphicon glyphicon-list"></span>
                                        &nbsp;{ detailsName}
                                </button>
                            </div>
                            {this.props.cartItem.ProductType != ProductTypeEnum.Donation && <DeliveryRule
                                cartItem={this.props.cartItem}
                                onUpdateDeliveryMethod={(isMailDelivery, isEticketDelivery, shippingFeeId) => this.handleUpdateDeliveryMethod(isMailDelivery, isEticketDelivery, shippingFeeId)}
                                emphasisOnUnsetShipping={this.props.emphasisOnUncompletedThings}
                            />}
                            <div className="btn-group visible-xs">
                                <button type="button" className={cIf({ btn: true, "btn-default": true, "btn-xs": true, active: this.state.detailsShown } )} onClick={() => this.handleShowDetails()}>
                                    <span className="glyphicon glyphicon-list"></span>
                                    &nbsp;{ detailsName}
                                </button>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-xs-12">
                            {this.state.detailsShown && hasSubProduct &&
                                this.props.cartItem.SubProducts.map((cartItem, index) => 
                                    <CartSubItem cartItem={cartItem} key={"subitem_" + index} onContentChange={this.props.onContentChange} showOnlyWholePricesOnInternet={this.props.cartItem.ShowOnlyWholePricesOnInternet} readOnly={this.props.readOnly}/>
                                )
                            }
                            {this.state.detailsShown && !hasSubProduct &&
                                this.props.cartItem.Tickets.map(ticket => 
                                    <Ticket ticket={ticket} key={ticket.ProductID} onRemoveTicket={this.props.onRemoveTicket} readOnly={this.props.readOnly}/>
                                )
                            }
                        </div>
                    </div>

                    {buttonModifySaleQuestionnaires}    
                </td>
                <td className="text-center">{this.props.cartItem.Quantity}</td>
                <td className="text-right">
                    {
                        accounting.formatMoney(
                            (siteSettings.taxesOnlyAtCheckout ? this.props.cartItem.PriceBeforeTaxes : this.props.cartItem.Price) 
                            + (siteSettings.taxesOnlyAtCheckout ? this.props.cartItem.ServiceFeesBeforeTaxes : this.props.cartItem.ServiceFees)
                        )
                    }
                </td>
            </tr>
        );
    }
}

CartItem.propTypes = {
    cartItem: PropTypes.object, // TODO: It would be nice to have a shape here
    onContentChange: PropTypes.func,
    onReloadCart: PropTypes.func,
    onRemoveItem: PropTypes.func,
    onRemoveTicket: PropTypes.func,
    onUpdateDeliveryMethod: PropTypes.func,
    readOnly: PropTypes.bool,
    emphasisOnUncompletedThings: PropTypes.bool,
    onModifySaleQuestionnaire: PropTypes.func
};

export default CartItem;
